import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CashFund, TransferStatusEnum } from '@libs/core/api';

enum CashFundStatusEnum {
  TRANSFERRED = 'transferred',
  DRAFT = 'draft',
  SENT = 'sent',
}

@Component({
  selector: 'ui-fund-cash-status-badge',
  templateUrl: './fund-cash-status-badge.component.html',
  styleUrls: ['./fund-cash-status-badge.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FundCashStatusBadgeComponent {
  @Input() purchase!: CashFund;
  @Input() currentUserId?: number;

  readonly CashFundStatusEnum = CashFundStatusEnum;

  get status(): string {
    const transferStatus =
      this.purchase.transferStatus || TransferStatusEnum.None;

    /**
     * If the transfer status is either 'ApprovalPending' or 'Transferred' and the assigned user is not the current user,
     * we should consider the status as 'Transferred'.
     */
    if (
      transferStatus !== TransferStatusEnum.None &&
      this.currentUserId &&
      this.purchase.assignedUser?.id !== this.currentUserId
    ) {
      return CashFundStatusEnum.TRANSFERRED;
    }

    if (this.purchase.isDraft) {
      return CashFundStatusEnum.DRAFT;
    }

    return CashFundStatusEnum.SENT;
  }
}
